import IDPUser from './IDPUser';
const KeycloakIDPAdapterBuilder = (keycloakClient, IDPUrl, realm, clientId) => {
  return {
    init: successCallback => {
      const initOptions = {
        onLoad: 'check-sso',
        // to keep logged-in state after refresh
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
      };
      keycloakClient.init(initOptions).then(() => {
        const user = keycloakClient.authenticated ? new IDPUser(keycloakClient.tokenParsed.preferred_username, keycloakClient.tokenParsed.locale, keycloakClient.tokenParsed.realm_access.roles[0]) : null;
        successCallback(user);
      });
    },
    initBM: successCallback => {
      const initOptions = {
        onLoad: 'check-sso',
        // to keep logged-in state after refresh
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
      };
      keycloakClient.init(initOptions).then(() => {
        const token = keycloakClient.tokenParsed;
        const idToken = keycloakClient.idTokenParsed;
        if (token?.preferred_username) {
          sessionStorage.setItem('sia.benchmarking.siaId', token.preferred_username);
        }
        idToken?.resource_access?.benchmarking?.roles.forEach(element => {
          // Sure we can have these stored in the same browser key, but * SHOULD WE * ?
          if (element.includes('bm_input_role')) {
            sessionStorage.setItem('sia.benchmarking.role-input', 'yes');
          }
          if (element.includes('bm_output_role')) {
            sessionStorage.setItem('sia.benchmarking.role-output', 'yes');
          }
        });
        const user = keycloakClient.authenticated ? new IDPUser(token.preferred_username, idToken.locale, idToken.resource_access?.benchmarking?.roles[0]) : null;
        successCallback(user);
      });
    },
    isLoggedIn: () => {
      return Boolean(keycloakClient.authenticated);
    },
    fetchCurrentUser: () => {
      return new Promise(resolve => {
        keycloakClient.loadUserProfile().then(userProfileResponse => {
          const currentUser = {
            siaId: userProfileResponse.username,
            firstName: userProfileResponse.firstName,
            lastName: userProfileResponse.lastName,
            email: userProfileResponse.email
          };
          resolve(currentUser);
        });
      });
    },
    createLoginUrl: (locale, redirectUrl, isBM = false) => {
      if (isBM) sessionStorage.setItem('sia.benchmarking.forceUserLanguage', true);else localStorage.setItem('sia.webPlatform.forceUserLanguage', true);
      return keycloakClient.createLoginUrl({
        locale: locale,
        redirectUri: redirectUrl ? redirectUrl : window.location.href
      });
    },
    createPasswordResetUrl: () => {
      return `${IDPUrl}/realms/${realm}/login-actions/reset-credentials?client_id=${clientId}#/password/request-reset`;
    },
    redirectToChangePasswordPage: () => {
      keycloakClient.login({
        action: 'UPDATE_PASSWORD'
      });
    },
    logout: (redirectUrl, isBM = false) => {
      if (isBM) sessionStorage.clear();
      keycloakClient.logout({
        redirectUri: redirectUrl || window.location.origin
      });
    },
    getToken: () => {
      return keycloakClient.token;
    },
    getClient: () => {
      return keycloakClient;
    }
  };
};
export default KeycloakIDPAdapterBuilder;